import { TFunction } from 'i18next';
import { ProcessingActivityRole, ProcessingActivityState } from 'models/processingActivity';
import ProcessingActivityDTO from '../processingActivity/processingActivityDTO';
import ReportRequestDTO from './ReportRequestDTO';

export class ReportRequest22DTO extends ReportRequestDTO {
  processingActivityColumns: string[];

  processingActivityRoles: Record<ProcessingActivityRole, string>;

  processingActivityStates: Record<ProcessingActivityState, string>;

  chartSeriesLabel: string;

  processingActivities: ProcessingActivityDTO[];

  constructor(report: ReportRequestDTO, t?: TFunction<string[]>) {
    super(report);
    this.processingActivities = [];
    this.processingActivityColumns = [];
    this.processingActivityRoles = {} as Record<ProcessingActivityRole, string>;
    this.processingActivityStates = {} as Record<ProcessingActivityState, string>;
    this.chartSeriesLabel = '';

    if (t) {
      this.processingActivityColumns = [
        t('processingActivity:ReportFields.DataSubject'),
        t('processingActivities:TabOverview.Column.Code'),
        t('processingActivities:TabOverview.Column.Name'),
        t('processingActivities:TabOverview.Column.Role'),
        t('processingActivities:TabOverview.Column.State'),
        t('processingActivities:TabOverview.Column.Data'),
        t('processingActivities:TabOverview.Column.Classifications'),
        t('processingActivity:ReportFields.ProcessorsAndRecipients'),
      ];
      this.processingActivityRoles = {
        [ProcessingActivityRole.Controller]: t('processingActivity:Role.Controller'),
        [ProcessingActivityRole.Processor]: t('processingActivity:Role.Processor'),
      };
      this.processingActivityStates = {
        [ProcessingActivityState.Concept]: t('processingActivity:State.Concept'),
        [ProcessingActivityState.Approved]: t('processingActivity:State.Approved'),
        [ProcessingActivityState.Archived]: t('processingActivity:State.Archived'),
        [ProcessingActivityState.AwaitingApproval]: t('processingActivity:State.AwaitingApproval'),
        [ProcessingActivityState.Review]: t('processingActivity:State.Review'),
      };

      this.chartSeriesLabel = t('processingActivities:TabOverview.Column.State');
    }
  }

  clone(): ReportRequest22DTO {
    const output = new ReportRequest22DTO(this);
    output.processingActivities = [...this.processingActivities];
    output.processingActivityColumns = [...this.processingActivityColumns];
    output.processingActivityRoles = { ...this.processingActivityRoles };
    output.processingActivityStates = { ...this.processingActivityStates };
    output.chartSeriesLabel = this.chartSeriesLabel;

    return output;
  }
}
